import { IAbUseExperiment } from '../../types/abUseExperiment';
import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): IAbUseExperiment[] => state.abUseExperiments;

export function isAbUseExperimentGroup(experiments: IAbUseExperiment[], experimentName: string, targetGroup: string) {
  const experiment = experiments.find(e => e.experimentName === experimentName);

  if (experiment) {
    return experiment.groupName === targetGroup;
  }

  return false;
}
